import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Sparkles, Star, Users } from 'lucide-react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center overflow-hidden bg-slate-900">
        <div className="absolute inset-0 z-0">
          <img 
            src="https://images.unsplash.com/photo-1513151233558-d860c5398176?auto=format&fit=crop&q=80" 
            alt="About Us" 
            className="w-full h-full object-cover opacity-40 scale-110"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent to-slate-900" />
        </div>
        
        <div className="relative z-10 text-center px-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="font-serif-display text-5xl md:text-7xl text-white mb-6">Our Story</h1>
            <p className="text-slate-300 text-lg md:text-xl max-w-2xl mx-auto font-light leading-relaxed">
              Transforming ordinary spaces into extraordinary memories since 2018.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Content Section */}
      <section className="max-w-4xl mx-auto px-6 py-24">
        <div className="grid gap-16">
          <motion.div 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="space-y-6"
          >
            <h2 className="text-3xl font-serif-display text-slate-900">Where Magic Begins ✨</h2>
            <div className="space-y-4 text-slate-600 leading-relaxed text-lg">
              <p>
                YoursDreamDecoration started with a simple belief: that every celebration deserves to be magical. What began as a small team of passionate designers in Noida has now grown into one of Delhi NCR's most trusted decoration services.
              </p>
              <p>
                We specialize in creating bespoke setups for Birthdays, Anniversaries, Baby Showers, and all life's special milestones. Our signature "Light Luxury" style blends modern aesthetics with warm, festive vibes to create spaces that don't just look good, but feel alive.
              </p>
            </div>
          </motion.div>

          {/* Values */}
          <div className="grid md:grid-cols-2 gap-8">
            {[
              { icon: <Heart className="text-pink-500" />, title: "Built with Love", desc: "We treat every event as if it were our own family celebration." },
              { icon: <Sparkles className="text-amber-500" />, title: "Premium Quality", desc: "We use only high-grade materials and professional design techniques." },
              { icon: <Star className="text-blue-500" />, title: "Customer First", desc: "Your dream is our mission. We customize until it's perfect." },
              { icon: <Users className="text-green-500" />, title: "Expert Team", desc: "Our decorators are trained professionals with years of experience." }
            ].map((v, i) => (
              <motion.div 
                key={i}
                whileHover={{ y: -5 }}
                className="p-8 rounded-3xl bg-slate-50 border border-slate-100 flex gap-5"
              >
                <div className="w-12 h-12 rounded-2xl bg-white shadow-sm flex items-center justify-center shrink-0">
                  {v.icon}
                </div>
                <div>
                  <h3 className="font-bold text-slate-900 mb-2">{v.title}</h3>
                  <p className="text-slate-500 text-sm">{v.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
